export default __webpack_public_path__ + "static/media/ic_more_horizontal.9746a5ea.svg";